import axios from "axios";
import authHeader, { twoFactorAuthHeader } from "./AuthHeader";


// const API_BASE_URL = 'https://sandbox.api.halalwealth.co/services';
const getAllBank = () => {
    return axios.get( "/api/get-banks");
}
const getUserBanks = () => {
    return axios.get( "/api/user-bankDetail", { headers: authHeader() });
}
const getTransactionHistory = () => {
    return axios.get( "/api/admin/transaction-history", { headers: authHeader() });
}
const refreshToken = () => {
    return axios.get( "/api/admin/refresh-token-admin", { headers: authHeader() });
}
const verifyBankAccount = (accNum, bankCode) => {
    return axios.get( `/api/verify-accountNumber?accountNumber=${accNum}&bankCode=${bankCode}`, { headers: authHeader() });
}
const getNextOfKin = () =>{
    return axios.get( "/api/admin/next-of-kin", { headers: authHeader() });
}
const getAllProject = (location, maxPrice, minPrice,projectName, projectType) =>{
    return axios.get( `/api/all-projects?location=${location}&maxPrice=${maxPrice}&minPrice=${minPrice}&projectName=${projectName}&projectType=${projectType}`, { headers: authHeader() });
}
const getSingleProject = (id) =>{
    return axios.get( `/api/listing?id=${id}`, { headers: authHeader() });
}
const getAllInvestment = () =>{
    return axios.get( `/api/admin/get-investment`, { headers: authHeader() });
}
const getMonthlyInvestmentReport= () =>{
    return axios.get( `/api/monthly-investment-report`, { headers: authHeader() });
}
const getApprovedProjectRequest = (id) =>{
    return axios.get( `/api/approve-project?projectId=${id}`, { headers: authHeader() });
}
const getDeclinedProjectRequest = (id) =>{
    return axios.get( `/api/decline-project?projectId=${id}`, { headers: authHeader() });
}
const getWeeklyInvestmentReport = () =>{
    return axios.get( `/api/weekly-investment-report`, { headers: authHeader() });
}
const getCustomInvestmentReport = (startDate, endDate) =>{
    return axios.get( `/api/custom-investmentList-report?endDate=${endDate}&startDate=${startDate}`, { headers: authHeader() });
}
const getCustomInvestmentList = (startDate, endDate) =>{
    return axios.get( `/api/custom-investmentList-report?endDate=${endDate}&startDate=${startDate}`, { headers: authHeader() });
}
const getWeeklyInvestmentList = () =>{
    return axios.get( `/api/weekly-investmentList-report`, { headers: authHeader() });
}
const getMonthlyInvestmentList = () =>{
    return axios.get( `/api/monthly-investment-report`, { headers: authHeader() });
}

const getUserInvestment = () =>{
    return axios.get( `/api/monthly-investment-report`, { headers: authHeader() });
}
const getAllUsers = () =>{
    return axios.get( `/api/admin/get-all-users`, { headers: authHeader() });
}
const getAllUser = () =>{
    return axios.get( `/api/admin/get-all-user`, { headers: authHeader() });
}
const getAllprojectListed = (startDate, endDate) =>{
    return axios.get( `/api/all-projects-listed?endDate=${endDate}&startDate=${startDate}`, { headers: authHeader() });
}
const getDeclineProject = (id) =>{
    return axios.get( `/api/decline-project?id=${id}`, { headers: authHeader() });
}
const getAcceptProject = (id) =>{
    return axios.get( `/api/approve-project?id=${id}`, { headers: authHeader() });
}
const getProjectListed = (startDate, endDate) =>{
    return axios.get( `/api/return-all-properties?endDate=${endDate}&startDate=${startDate}`, { headers: authHeader() });
}
const getAllCount = () =>{
    return axios.get( `/api/admin/all-count-api`, { headers: authHeader() });
}
const getAllLiqui = () =>{
    return axios.get( `/api/liquidation-request`, { headers: authHeader() });
}
const approveLiqui =(id) =>{
    return axios.get( `/api/approve-liquidation-request?investmentId=${id}`, { headers: authHeader() });
}
const deApproveLiqui=(id) =>{
    return axios.get( `/api/decline-liquidation-request?investmentId=${id}`, { headers: authHeader() });
}
const getWithdrawerList=() =>{
    return axios.get( `/api/list-transfers`, { headers: authHeader() });
}
const getNotification=() =>{
    return axios.get( `/api/get-notifications`, { headers: authHeader() });
}

const getAdminNotifications = (page = 0, limit = 10) => {
    return axios.get(`/api/admin/notifications?page=${page}&limit=${limit}`, { headers: authHeader() });
}

const getAdminNotificationUnreadCount = () => {
    return axios.get(`/api/admin/notifications/unread-count`, { headers: authHeader() });
}

const getAdminNotificationInbox = () => {
    return axios.get(`/api/admin/notifications/inbox`, { headers: authHeader() });
}

const get2faSetup=() =>{
    return axios.get( `/api/admin/setup-2fa`, { headers: twoFactorAuthHeader() });
}
const getAdminUsers=() =>{
    return axios.get( `/api/admin/get-all-users`, { headers: authHeader() });
}

// const getAllUserHalal = (startDate, endDate)=>{
//    let url = "/api/onboarding/get-all-users";
//     const params = new URLSearchParams();

//     if (startDate) params.append("startDate", startDate);
//     if (endDate) params.append("endDate", endDate);

//     if (params.toString()) {
//         url += `?${params.toString()}`;
//     }

//     return axios.get(url, { headers: authHeader() });
// }
const getAllUserHalal = (startDate, endDate, page = 0, q = "", status = "") => {
    let url = "/api/admin/users";
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (q) params.append("q", q);
    if (status !== undefined && status !== "") params.append("status", status);
    
    if (page !== undefined && page !== null) params.append("page", page);
    params.append("limit", 10); 
    

    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    return axios.get(url, { headers: authHeader() });
}


const getRole=() =>{
    return axios.get( `/api/admin/get-roles`, { headers: authHeader() });
}

const getDashboardCount=(startDate, endDate) =>{
    return axios.get( `/api/custom-investment-report?endDate=${endDate}&startDate=${startDate}`, { headers: authHeader() });
}


const getAllInvestments = ()=>{
    return axios.get(`/api/admin/investments/categories`, {headers:authHeader()})
}
const getInvestmentPlan = (categoryId) => {
  return axios.get(`/api/admin/investments/categories/${categoryId}?page=0&limit=8`, {
    headers: authHeader(),
  });
};
const getInvestmentPlanUsers = (investmentId) => {
  return axios.get(`/api/admin/investments/${investmentId}/users`, {
    headers: authHeader(),
  });
};
const getInvestmentStats = (investmentId) => {
  return axios.get(`/api/admin/investments/${investmentId}/stats`, {
    headers: authHeader(),
  });
};
const getUserHalal = (id) => {
  return axios.get(`/api/admin/users/${id}`, {
    headers: authHeader(),
  });
};


const getAllSubInvestments = (category)=>{
    let url = "/api/investment/investment-sub-category";
    const params = new URLSearchParams();

    if (category) params.append("category", category);

    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    return axios.get(url, { headers: authHeader() });
   
}
const getAllTransaction = (startDate, endDate)=>{
    return axios.get(`/api/wallet/transaction-history-admin?endDate=${endDate}&startDate=${startDate}`, {headers:authHeader()})
}
const getAllSavings = (startDate, endDate) =>{
    return axios.get( `/api/savings/all-investment?endDate=${endDate}&startDate=${startDate}`, { headers: authHeader() });
}

const getSavingsCategory = ()=>{
    return axios.get(`/api/admin/savings/savings-category`, {headers:authHeader()})
}

const getSavingsStats = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.savingsType) queryParams.append('savingsType', params.savingsType);
  if (params.planType) queryParams.append('planType', params.planType);

  const queryString = queryParams.toString();
  const url = `/api/admin/savings/stats${queryString ? `?${queryString}` : ''}`;

  return axios.get(url, { headers: authHeader() });
}

const getAllAssest = (startDate, endDate) =>{
    return axios.get( `/api/asset/all-assets?endDate=${endDate}&startDate=${startDate}`, { headers: authHeader() });
}

const getAssetProducts = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.status) queryParams.append('status', params.status);
  if (params.categoryId) queryParams.append('categoryId', params.categoryId);
  if (params.page !== undefined && params.page !== null) queryParams.append('page', params.page);
  if (params.limit !== undefined && params.limit !== null) queryParams.append('limit', params.limit);
  if (params.q) queryParams.append('q', params.q);

  const queryString = queryParams.toString();
  return axios.get(`/api/admin/asset/products${queryString ? `?${queryString}` : ''}`, { headers: authHeader() });
}

const getAssetProductStats = () => {
  return axios.get('/api/admin/asset/products/stats', { headers: authHeader() });
}

const getAssestCategory = () =>{
    return axios.get( `/api/admin/asset/categories`, { headers: authHeader() });
}

const getAssetFinancingRequests = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.status) queryParams.append('status', params.status);
  if (params.page !== undefined && params.page !== null) queryParams.append('page', params.page);
  if (params.limit !== undefined && params.limit !== null) queryParams.append('limit', params.limit);
  if (params.q) queryParams.append('q', params.q);

  const queryString = queryParams.toString();
  return axios.get(`/api/admin/asset/requests${queryString ? `?${queryString}` : ''}`, { headers: authHeader() });
}

const getAssetFinancingRequest = (requestId) => {
  return axios.get(`/api/admin/asset/requests/${requestId}`, { headers: authHeader() });
}

const getAssetRepaymentsOverview = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.page !== undefined && params.page !== null) queryParams.append('page', params.page);
  if (params.limit !== undefined && params.limit !== null) queryParams.append('limit', params.limit);

  const queryString = queryParams.toString();
  return axios.get(`/api/admin/asset/requests/repayments/overview${queryString ? `?${queryString}` : ''}`, { headers: authHeader() });
}

const getAssetRepaymentSchedule = (requestId) => {
  return axios.get(`/api/admin/asset/requests/${requestId}/repayments/schedule`, { headers: authHeader() });
}

const getAssetRecommendations = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.status) queryParams.append('status', params.status);
  if (params.page !== undefined && params.page !== null) queryParams.append('page', params.page);
  if (params.limit !== undefined && params.limit !== null) queryParams.append('limit', params.limit);

  const queryString = queryParams.toString();
  return axios.get(`/api/admin/asset/recommendations${queryString ? `?${queryString}` : ''}`, { headers: authHeader() });
}

const getAssetRecommendationStats = () => {
  return axios.get('/api/admin/asset/recommendations/stats', { headers: authHeader() });
}

const deactivateUser = (id, transactionPin) => {
    return axios.post(
        `/api/admin/deActivate-user?id=${id}&transactionPin=${transactionPin}`,
        {}, 
        { headers: authHeader() }
    );
};

const getNotifications = () => {
  return axios.get(`/api/admin/get-notifications`, { headers: authHeader() });
};

const getWallet = () => {
  return axios.get(
    `api/admin/wallet/transactions`,
    { headers: authHeader() }
  );
};
const getWalletByReference = (reference) => {
  return axios.get(
    `api/admin/wallet/transactions/${reference}`,
    { headers: authHeader() }
  );
};


const getAllSavingsFiltered = (params) => {
  const queryParams = new URLSearchParams();
  
  if (params.createdBy) queryParams.append('createdBy', params.createdBy);
  if (params.emailAddress) queryParams.append('emailAddress', params.emailAddress);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  if (params.savingStatus) queryParams.append('savingStatus', params.savingStatus);
  if (params.savingsType) queryParams.append('savingsType', params.savingsType);
  
  const queryString = queryParams.toString();
  const url = `api/admin/savings/all-savings${queryString ? `?${queryString}` : ''}`;
  
return axios.get(url, { headers: authHeader() });
}

const getSavingsByPlanType = (params) => {
  const queryParams = new URLSearchParams();
  
  if (params.page !== undefined) queryParams.append('page', params.page);
  if (params.limit !== undefined) queryParams.append('limit', params.limit);
  if (params.type) queryParams.append('type', params.type);
  if (params.status) queryParams.append('status', params.status);
  if (params.categoryId) queryParams.append('categoryId', params.categoryId);
  if (params.q) queryParams.append('q', params.q);
  
  const queryString = queryParams.toString();
  const url = `api/admin/savings/users${queryString ? `?${queryString}` : ''}`;
  
  return axios.get(url, { headers: authHeader() });
}

const getSavingsHistory = (savingsId, page = 0, limit = 10) => {
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  
  const queryString = queryParams.toString();
  const url = `api/admin/savings/users/${savingsId}/history?${queryString}`;


  
  return axios.get(url, { headers: authHeader() });
}

const getTaxProfiles = () => {
  return axios.get('/api/admin/tax-profiles', { headers: authHeader() });
}

const getInsuranceProfiles = () => {
  return axios.get('/api/admin/insurance-profiles', { headers: authHeader() });
}

const getServices = {
    getAllSavingsFiltered,
    getSavingsByPlanType,
    getSavingsHistory,
    getSavingsStats,
    getWalletByReference,
    getWallet,
    getInvestmentPlan,
    getSavingsCategory,
    getAllBank,
    getAllSubInvestments,
    getAllSavings,
    getAllAssest,
    getDashboardCount,
    getAdminUsers,
    getRole,
    verifyBankAccount,
    getUserBanks,
    getTransactionHistory,
    refreshToken,
    getNextOfKin,
    getAllProject,
    getSingleProject,
    getAllInvestment,
    getMonthlyInvestmentReport,
    getApprovedProjectRequest,
    getDeclinedProjectRequest,
    getWeeklyInvestmentReport,
    getCustomInvestmentReport,
    getCustomInvestmentList,
    getWeeklyInvestmentList,
    getMonthlyInvestmentList,
    getUserInvestment,
    getAllUsers,
    getAllUser,
    getAllprojectListed,
    getAcceptProject,
    getDeclineProject,
    getProjectListed,
    getAllCount,
    getAllLiqui,
    approveLiqui,
    deApproveLiqui,
    getWithdrawerList,
    getNotification,
    getAdminNotifications,
    getAdminNotificationUnreadCount,
    getAdminNotificationInbox,
    get2faSetup,
    getAllUserHalal,
    getAllInvestments,
    getAllTransaction,
    getAssestCategory,
    getAssetProducts,
    getAssetProductStats,
    getAssetFinancingRequests,
    getAssetFinancingRequest,
    getAssetRepaymentsOverview,
    getAssetRepaymentSchedule,
    getAssetRecommendations,
    getAssetRecommendationStats,
    deactivateUser,
    getNotifications,
    getInvestmentPlanUsers,
    getInvestmentStats,
    getUserHalal,
    getTaxProfiles,
    getInsuranceProfiles
}

export default getServices;
